import { render } from "./DateTabletFormComponent.vue?vue&type=template&id=0a4bb648"
import script from "./DateTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./DateTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__